import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { DatepickerLanguageService } from '@services/datepicker-language';
import { BsDatepickerModule, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { LoaderModule } from '@ui/loader';
import { SidebarModule } from '@ui/sidebar';
import { ManageAlertComponent } from '@app/manage-alert';
import { RatingModule } from '@ui/rating/rating.module';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { environment } from '@environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { SharedModule } from '@app/shared/shared.module';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CoreModule } from './core/core.module';
import { AppRoutingModule } from './app-routing-module';

import { AppComponent } from './app.component';
import { ServiceService } from '@services/service/service.service';

const config: SocketIoConfig = {
    url: environment.pmpSockets,
    options: {
        transports: ['websocket'],
        autoConnect: false,
    },
};

function initializeApp(serviceService: ServiceService) {
    return () => serviceService.initServices();
}

@NgModule({
    declarations: [AppComponent, ManageAlertComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        CoreModule,
        SidebarModule,
        LoaderModule,
        RatingModule,
        BsDatepickerModule.forRoot(),
        SocketIoModule.forRoot(config),
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            registrationStrategy: 'registerImmediately',
        }),
        SharedModule,
        BrowserAnimationsModule,
        MatAutocompleteModule,
    ],
    providers: [
        DatepickerLanguageService,
        BsLocaleService,
        BsModalService,
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [ServiceService],
            multi: true
        }
    ],
    bootstrap: [AppComponent],
    exports: [RatingModule, SharedModule],
})
export class AppModule {}
